import {Component, OnInit, effect, input, output, signal, computed, ChangeDetectionStrategy} from "@angular/core"
import {FormsModule} from "@angular/forms"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-string-input",
    templateUrl: "./string-input.component.html",
    styleUrls: ["./string-input.component.scss"],
    imports: [FormsModule],
})
export class StringInputComponent implements OnInit {
    readonly $validate = input<(x: string) => boolean>(undefined, {alias: "validate"})
    readonly $convert = input<{
        toDisplay: (x: string) => string
        fromDisplay: (x: string) => string
    }>()
    readonly valueChange = output<string>()
    readonly $disabled = input(false, {alias: "disabled"})
    readonly $readonly = input(false, {alias: "readonly"})
    readonly $isButton = input(false, {alias: "isButton"})

    readonly $value = input.required<string>({alias: "value"})

    constructor() {
        effect(() => {
            const value = this.$value()
            const convert = this.$convert()
            this.$valueString.set(convert ? convert.toDisplay(value) : value)
        })
    }

    private readonly $editing = signal(false)
    private readonly $valueString = signal("")
    readonly $editValid = signal(true)
    private readonly $_editString = signal<string | null>(null)

    readonly $editString = computed(() => {
        if (this.$editing()) {
            return this.$_editString()
        }
        return this.$valueString()
    })

    setEditString(str: string) {
        if (this.$editing()) {
            this.$_editString.set(str)
        }
        try {
            const convert = this.$convert()
            const value = convert ? convert.fromDisplay(str) : str
            const validate = this.$validate()
            const isValid = validate ? validate(value) : true
            this.$editValid.set(isValid)
            if (isValid) {
                this.valueChange.emit(value)
            }
        } catch {
            this.$editValid.set(false)
        }
    }

    ngOnInit(): void {}

    onFocus() {
        this.$_editString.set(this.$valueString())
        this.$editing.set(true)
        this.$editValid.set(true)
    }

    onBlur() {
        this.$editing.set(false)
        this.$_editString.set(null)
        this.$editValid.set(true)
    }
}
